export default {
  SET_utils(state, payload) {
    Object.keys(state).map((key) => {
      state[key] = payload[key]
    })
  },
}
